import "./ExtratoResumo.css";
import { formatDateBRInBrasilia, toDateOnlyTimestampInBrasilia } from "../../../utils/dateBrasilia";

const ExtratoResumo = ({ itensLista = [], limite = 8 }) => {
  const itens = Array.isArray(itensLista) ? itensLista : [];

  const formatCurrencyBRL = (value) =>
    Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  // normaliza valor para calculo do saldo
  // Regra: se entry_type === DEBIT => negativo
  const getSignedAmount = (item) => {
    const v = Number(item.amount ?? item.purchase_amount ?? 0) || 0;
    // se vier amount ja negativo, respeita; senao aplica regra
    if (Number(item.amount) < 0) return Number(item.amount);
    if (item.entry_type === "DEBIT") return -Math.abs(v);
    return Math.abs(v);
  };

  const buildDesc = (item) => {
    const description = String(item.description || "").trim();
    const clientName = String(item.client_name || "").trim();
    const orderNumber = String(item.order_number || "").trim();

    const isOmiePedido = /pedido\s+omie/i.test(description) || item.source === "OMIE";
    const orderFromDescription = description.match(/pedido\s+omie\s*#?\s*([A-Za-z0-9-]+)/i)?.[1] || "";
    const numeroPedido = orderFromDescription || orderNumber;

    if (isOmiePedido && numeroPedido) {
      return `Pedido ${numeroPedido}${clientName ? ` - ${clientName}` : ""}`;
    }

    const base = description || clientName || (item.entry_type === "DEBIT" ? "Debito" : "Credito");
    const hasOrderInBase = orderNumber && base.toLowerCase().includes(orderNumber.toLowerCase());
    const extra = orderNumber && !hasOrderInBase ? ` - ${orderNumber}` : "";
    return `${base}${extra}`;
  };

  // ordena por data mais recente
  const sorted = [...itens].sort((a, b) => {
    const da = toDateOnlyTimestampInBrasilia(b.entry_date || b.created_at) || 0;
    const db = toDateOnlyTimestampInBrasilia(a.entry_date || a.created_at) || 0;
    return da - db;
  });
  const view = sorted.slice(0, limite);

  // saldo rodando (mostra saldo apos cada linha)
  // Para bater com a ordem exibida (mais recente em cima), calculamos do mais antigo pro mais novo e depois mapeamos.
  const asc = [...view].sort((a, b) => {
    const da = toDateOnlyTimestampInBrasilia(a.entry_date || a.created_at) || 0;
    const db = toDateOnlyTimestampInBrasilia(b.entry_date || b.created_at) || 0;
    return da - db;
  });
  let running = 0;
  const saldoMap = new Map();
  asc.forEach((it) => {
    running += getSignedAmount(it);
    saldoMap.set(it.id, running);
  });

  return (
    <section className="extrato-card">
      <div className="extrato-header">
        <div className="extrato-title">
          <span>📄</span>
          <span>Extrato (resumo)</span>
        </div>
        <a href="/extrato" className="extrato-link">Ver extrato completo</a>
      </div>

      <div className="extrato-table">
        <div className="extrato-row extrato-head">
          <div>Data</div>
          <div>Historico</div>
          <div className="right">Debito</div>
          <div className="right">Credito</div>
          <div className="right">Saldo</div>
        </div>

        {view.length === 0 ? (
          <div className="extrato-empty">Nenhuma movimentacao encontrada.</div>
        ) : (
          view.map((item) => {
            const signed = getSignedAmount(item);
            const isDebit = signed < 0;
            const debit = isDebit ? formatCurrencyBRL(Math.abs(signed)) : "";
            const credit = !isDebit ? formatCurrencyBRL(signed) : "";
            const saldo = formatCurrencyBRL(saldoMap.get(item.id) || 0);

            return (
              <div key={item.id} className="extrato-row">
                <div>{formatDateBRInBrasilia(item.entry_date || item.created_at)}</div>
                <div className="hist">{buildDesc(item)}</div>

                <div className={`right ${isDebit ? "debito" : ""}`}>{debit}</div>
                <div className={`right ${!isDebit ? "credito" : ""}`}>{credit}</div>
                <div className="right saldo">{saldo}</div>
              </div>
            );
          })
        )}
      </div>
    </section>
  );
};

export default ExtratoResumo;

